import { render } from "./StreamingBefore.vue?vue&type=template&id=855c9d9a&scoped=true"
import script from "./StreamingBefore.vue?vue&type=script&lang=js"
export * from "./StreamingBefore.vue?vue&type=script&lang=js"

import "./StreamingBefore.vue?vue&type=style&index=0&id=855c9d9a&scoped=true&lang=css"

import exportComponent from "D:\\project\\weshow-front-rococo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-855c9d9a"]])

export default __exports__